export enum STOP_STATUS {
  CONFIRMED = 'confirmed',
  UNCONFIRMED = 'unconfirmed',
  PREDICTED = 'predicted',
}
